var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8014_14048)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 46,
    rx: 4,
    fill: "#282B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0156 37.6436L34.9247 37.6894C34.2186 37.9955 33.4011 37.8074 32.9327 37.2311L24.9401 27.4208C24.525 26.9118 23.8303 26.7007 23.1752 26.8845L10.5545 30.4322C9.81381 30.6439 9.03203 30.3484 8.65062 29.7123C8.2692 29.0762 8.38386 28.2593 8.92985 27.7227L29.1867 7.76465C29.6295 7.26438 30.3284 7.05812 30.9677 7.23909C31.607 7.42005 32.0656 7.95395 32.1361 8.59952L36.0223 35.8928C36.1237 36.6193 35.7121 37.3352 35.0156 37.6436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9266 15.3761L7.51934 24.925",
    stroke: "white",
    strokeWidth: 1.70925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8807 8.92993L9.59754 18.2152",
    stroke: "white",
    strokeWidth: 1.70925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8014_14048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 46,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4415d89b70a6283e4bc5324771504f28.svg";
export { ForwardRef as ReactComponent };